export const CHECKBOX_CONTAINER_STYLES = ['flex', 'items-center', 'gap-x-3'].join(' ');

export const CHECKBOX_STYLES = ['cursor-pointer'].join(' ');

export const CHECKBOX_LABEL_STYLES = ['cursor-pointer'].join(' ');

export const ERROR_MESSAGE_STYLES = ['text-red-500'].join(' ');
